import Card from '@material-ui/core/Card';
import React, { Component } from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import CardActions from '@material-ui/core/CardActions'
import { FormControl, Select, MenuItem, InputLabel, Popover, IconButton, Typography, CardContent} from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help';
import PopupState, { bindTrigger, bindPopover} from 'material-ui-popup-state'

import InputAnswer from './answers/Input'
import Toggle from './answers/Toggle'
import Height from './answers/Height'
import DateOfBirth from './answers/DateOfBirth'

import { withStyles } from '@material-ui/core/styles';
import DropdownIncremental from './answers/DropdownIncremental';

const styles = theme => ({
    root: {
        
    },
    header: {
        textAlign: 'center',
        marginBottom: '0px'
    },
    card: {
        padding: '0 1vw 1em 1vw'
    },
    center: {
        textAlign: 'center',
        justifyContent: 'center'
    },
    smallTitle: {
        fontSize: '1.3em'
    },
    regularTitle: {
        fontSize: '1.5em'
    }
});

class Question extends Component {
    constructor(props){
        super(props);
        this.state = {
            answer: props.question[0].Responses[0].Response,
            helpOpen: false
        }

    }

    componentDidUpdate(prevProps) {
        if(this.props.question[0].QuestionStandardContent !== prevProps.question[0].QuestionStandardContent){
            this.setState({answer: this.props.question[0].Responses[0].Response})
        }
    }

    changeAnswer = ev => {
        console.log(ev.target.value)
        this.setState({answer: ev.target.value})
        this.props.updateResponseValue(ev.target.value)
    }

    handleMouseDown = ev => {
        this.setState({
            helpOpen: !this.state.helpOpen
        })
    }

    handleClose = ev => {
        console.log("handleClose")
        this.setState({
            helpOpen: false
        })
        return;
    }

    render() {
        const {classes} = this.props;
        let answertype = null;
        
        switch(this.props.question[0].QuestionTypeKeyName){
            case 'INTEGER INPUT':
            case 'DECIMAL INPUT':
                answertype = <InputAnswer question={this.props.question[0]} updateResponseValue={this.props.updateResponseValue.bind(this)} helpOpen={this.state.helpOpen} validation={this.props.validationMessages}/>
                break
            case 'HEIGHT':
                if(this.props.uom == "IMPERIAL"){
                    answertype = <Height question={this.props.question[0]} updateResponseValue={this.props.updateResponseValue.bind(this)} prompts={this.props.questionPrompts} validation={this.props.validationMessages}/>
                }
                else{
                    answertype = <InputAnswer question={this.props.question[0]} updateResponseValue={this.props.updateResponseValue.bind(this)} validation={this.props.validationMessages} />
                }
                
                break
            case 'DATE INPUT':
                answertype  = <DateOfBirth question={this.props.question[0]} updateResponseValue={this.props.updateResponseValue.bind(this)} questionPrompts={this.props.questionPrompts} validation={this.props.validationMessages} prompts={this.props.questionPrompts} />
                break
            case 'DROPDOWN INCREMENTAL':
                answertype = <DropdownIncremental question={this.props.question[0]} updateResponseValue={this.props.updateResponseValue.bind(this)}/>
                break;
            case 'DROPDOWN':
                answertype = 
                            //<Dropdown question={this.props.question[0]}
                            //    changeAnswer={this.changeAnswer.bind(this)}/>
                
                            <FormControl variant="outlined" style={{width:'100%'}}>
                                <InputLabel id="dropdown-label">{this.props.questionPrompts.Dropdown}</InputLabel>
                                <Select
                                  labelId="dropdown-label"
                                  value={this.state.answer}
                                  onChange={this.changeAnswer}
                                  label={this.props.questionPrompts.Dropdown}
                                  labelWidth={105}
                                >
                                {this.props.question[0].Answers.sort((a, b) => (parseInt(a.AnswerSequenceInQuestion) - parseInt(b.AnswerSequenceInQuestion))).map(item => <MenuItem style={{whiteSpace: 'normal'}} value={item.AnswerId}>{item.AnswerStandardContent}</MenuItem>)}
                                </Select>
                            </FormControl>
                break
            default:
                answertype = <RadioGroup value={this.state.answer} onChange={this.changeAnswer}>
                        {this.props.question[0].Answers.sort((a, b) => (parseInt(a.AnswerSequenceInQuestion) - parseInt(b.AnswerSequenceInQuestion))).map(item => <Toggle question={this.props.question[0]} answer={item}/>)}
                        </RadioGroup>
                break
            }
            //make the icon
        let helpIcon = null
        if(this.props.question[0].QuestionHelpText.length){
            helpIcon = <PopupState variant="popover" popupId="help-popover">
                    {popupState => (
                        <span style={{float:'right', width: '35px', top:'-15px', position:'relative'}}>
                            
                        <IconButton aria-label="additional help text" variant="contained"  {...bindTrigger(popupState)} style={{color:'rgba(0,0,0,0.54)', padding:'12px', borderRadius:'50%'}} onMouseDown={this.handleMouseDown}>
                            <HelpIcon/>
                        </IconButton>
                        <Popover 
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }} 
                            onExited={this.handleClose}
                            >
                            <Typography style={{maxWidth:'330px', padding:'10px'}} dangerouslySetInnerHTML={{__html:this.props.question[0].QuestionHelpText}}></Typography>
                        </Popover>
                        </span>
                    )}
                </PopupState>
        }

        //font size based on content length or help icon
        let fontsize = '1.5em'
        if (this.props.question[0].QuestionStandardContent.length >= 80 || this.props.question[0].QuestionHelpText.length){
            fontsize = '1.3em'
        }

        return (
            <Card raised="true" style={{minHeight:'350px'}}>
                <div style={{display: 'inline'}}>
                <CardContent>
                {helpIcon}
                   <Typography 
                        variant='h5' style={{fontSize: fontsize}}>
                        {this.props.question[0].QuestionStandardContent}
                    </Typography>
                     
                </CardContent>
                
                
                </div>
                
                <CardActions style={{display:'block', paddingLeft:'15px', paddingRight:'15px'}}>
                    {answertype}
                </CardActions>
            </Card>
        )
    }
}
//<CardHeader title={this.props.question[0].QuestionStandardContent} titleTypographyProps={{fontSize: '25px'}}/>
export default withStyles(styles)(Question);